import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { forwardRefAndName } from "../../../../lib/forwardRefAndName";
import { BaseIcon } from "../../BaseIcon";
export var ArrowCDownIcon24Regular = forwardRefAndName('ArrowCDownIcon24Regular', function (props, ref) {
  return /*#__PURE__*/(
    React.createElement(BaseIcon, _extends({
      ref: ref,
      viewBoxSize: 24
    }, props), /*#__PURE__*/
    React.createElement("path", {
      d: "M20.617 7.881a.875.875 0 0 1 0 1.238l-6.407 6.407a3.125 3.125 0 0 1-4.42 0L3.384 9.119A.875.875 0 1 1 4.62 7.88l6.407 6.407a1.375 1.375 0 0 0 1.944 0l6.407-6.407a.875.875 0 0 1 1.238 0Z"
    }))
  );
});